module.exports = __webpack_public_path__ + "static/media/topic02.ad32eedb.jpg";